import {
  MANAGEMENT_OF_COMPANIES_SECTOR,
  SCIENTIFIC_SERVICES_SECTOR,
  UTILITIES_SECTOR,
} from '../industrySectorOptions';
import {
  ACCOMMODATION_SUB_SECTOR,
  ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR,
  ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR,
  ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR,
  ADMINISTRATIVE_SERVICE_SUB_SECTOR,
  AGENTS_AND_BROKERS_SUB_SECTOR,
  AGRICULTURE_SUPPORT_ACTIVITIES_SUB_SECTOR,
  AIR_TRANSPORTATION_SUB_SECTOR,
  AMBULATORY_CARE_SUB_SECTOR,
  AMUSEMENT_INDUSTRY_SUB_SECTOR,
  ANIMAL_AND_AGRICULTURE_SUB_SECTOR,
  APPAREL_MANUFACTURING_SUB_SECTOR,
  BEVERAGE_AND_TOBACCO_MANUFACTURING_SUB_SECTOR,
  BROADCASTING_PROVIDER_SUB_SECTOR,
  BUILDING_CONSTRUCTION_SUB_SECTOR,
  BUILDING_MATERIAL_DEALERS_SUB_SECTOR,
  CHEMICAL_MANUFACTURING_SUB_SECTOR,
  CLOTHING_RETAILERS_SUB_SECTOR,
  COMPUTER_AND_ELECTRONIC_MANUFACTURING_SUB_SECTOR,
  COMPUTING_INFRASTRUCTURE_SUB_SECTOR,
  COURIERS_SUB_SECTOR,
  CREDIT_INTERMEDIATION_SUB_SECTOR,
  CROP_PRODUCTION_SUB_SECTOR,
  DURABLE_GOODS_SUB_SECTOR,
  EDUCATIONAL_SERVICES_SUB_SECTOR,
  ELECTRICAL_EQUIPMENT_MANUFACTURING_SUB_SECTOR,
  EXECUTIVE_LEGISLATIVE_SUB_SECTOR,
  FABRICATED_METAL_MANUFACTURING_SUB_SECTOR,
  FISHING_HUNTING_TRAPPING_SUB_SECTOR,
  FOOD_MANUFACTURING_SUB_SECTOR,
  FOOD_RETAILERS_SUB_SECTOR,
  FOOD_SERVICES_AND_DRINKING_PLACES_SUB_SECTOR,
  FORESTRY_AND_LOGGING_SUB_SECTOR,
  FUNDS_TRUSTS_SUB_SECTOR,
  FURNITURE_MANUFACTURING_SUB_SECTOR,
  FURNITURE_RETAILERS_SUB_SECTOR,
  GASOLINE_DEALERS_SUB_SECTOR,
  HEALTH_RETAILERS_SUB_SECTOR,
  HEAVY_AND_CIVIL_ENGINEERING_CONSTRUCTION_SUB_SECTOR,
  HOSPITALS_SUB_SECTOR,
  INSURANCE_CARRIERS_SUB_SECTOR,
  JUSTICE_PUBLIC_ORDER_SUB_SECTOR,
  LAUNDRY_SERVICE_SUB_SECTOR,
  LEATHER_AND_ALLIED_PRODUCT_MANUFACTURING_SUB_SECTOR,
  LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR,
  MACHINERY_MANUFACTURING_SUB_SECTOR,
  MERCHANDISE_RETAILERS_SUB_SECTOR,
  MINING_SUB_SECTOR,
  MINING_SUPPORT_ACTIVITIES_SUB_SECTOR,
  MISCELLANEOUS_MANUFACTURING_SUB_SECTOR,
  MONETARY_BANK_SUB_SECTOR,
  MOTION_PIC_INDUSTRIES_SUB_SECTOR,
  MOTOR_VEHICLE_AND_PARTS_DEALERS_SUB_SECTOR,
  MUSEUMS_SUB_SECTOR,
  NATIONAL_SECURITY_SUB_SECTOR,
  NONDURABLE_GOODS_SUB_SECTOR,
  NONMETALLIC_MINERAL_MANUFACTURING_SUB_SECTOR,
  NURSING_FACILITIES_SUB_SECTOR,
  OIL_GAS_EXTRACTION_SUB_SECTOR,
  PAPER_MANUFACTURING_SUB_SECTOR,
  PERFORMING_ARTS_SUB_SECTOR,
  PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR,
  PIPELINE_TRANSPORTATION_SUB_SECTOR,
  PLASTICS_AND_RUBBER_MANUFACTURING_SUB_SECTOR,
  POSTAL_SERVICE_SUB_SECTOR,
  PRIMARY_METAL_MANUFACTURING_SUB_SECTOR,
  PRINTING_MANUFACTURING_SUB_SECTOR,
  PRIVATE_HOUSEHOLDS_SUB_SECTOR,
  PUBLISHING_INDUSTRIES_SUB_SECTOR,
  RAIL_TRANSPORTATION_SUB_SECTOR,
  REAL_ESTATE_SUB_SECTOR,
  RELIGIOUS_SUB_SECTOR,
  RENTAL_AND_LEASING_SUB_SECTOR,
  REPAIR_AND_MAINTENANCE_SUB_SECTOR,
  SCENIC_TRANSPORTATION_SUB_SECTOR,
  SECURITIES_COMMODITY_SUB_SECTOR,
  SOCIAL_ASSISTANCE_SUB_SECTOR,
  SPACE_RESEARCH_SUB_SECTOR,
  SPECIALTY_TRADE_CONTRACTORS_SUB_SECTOR,
  SPORTING_GOODS_RETAILERS_SUB_SECTOR,
  SUPPORT_ACTIVITIES_FOR_TRANSPORTATION_SUB_SECTOR,
  TELECOMMUNICATION_SUB_SECTOR,
  TEXTILE_MILLS_SUB_SECTOR,
  TEXTILE_PRODUCT_MILLS_SUB_SECTOR,
  TRANSIT_TRANSPORTATION_SUB_SECTOR,
  TRANSPORTATION_EQUIPMENT_MANUFACTURING_SUB_SECTOR,
  TRUCK_TRANSPORTATION_SUB_SECTOR,
  WAREHOUSING_AND_STORAGE_SUB_SECTOR,
  WASTE_MANAGEMENT_SUB_SECTOR,
  WATER_TRANSPORTATION_SUB_SECTOR,
  WEB_SEARCH_PORTALS_SUB_SECTOR,
  WOOD_PRODUCT_MANUFACTURING_SUB_SECTOR,
} from '../industrySubSectorOptions';

export const OILSEED_AND_GRAIN_INDUSTRY_GROUP = '1111';
export const VEGETABLE_AND_MELON_INDUSTRY_GROUP = '1112';
export const FRUIT_AND_TREE_NUT_INDUSTRY_GROUP = '1113';
export const GREENHOUSE_NURSERY_AND_FLORICULTURE_INDUSTRY_GROUP = '1114';
export const OTHER_CROP_FARMING_INDUSTRY_GROUP = '1119';
export const CATTLE_RANCHING_FARMING_INDUSTRY_GROUP = '1121';
export const HOD_AND_PIG_FARMING_INDUSTRY_GROUP = '1122';
export const POULTRY_AND_EGG_INDUSTRY_GROUP = '1123';
export const SHEEP_AND_GOAT_INDUSTRY_GROUP = '1124';
export const AQUACULTURE_INDUSTRY_GROUP = '1125';
export const OTHER_ANIMAL_PRODUCTION_INDUSTRY_GROUP = '1129';
export const TIMBER_TRACK_OPERATIONS_INDUSTRY_GROUP = '1131';
export const FOREST_NURSERIES_INDUSTRY_GROUP = '1132';
export const LOGGING_INDUSTRY_GROUP = '1133';
export const FISHING_INDUSTRY_GROUP = '1141';
export const HUNTING_AND_TRAPPING_INDUSTRY_GROUP = '1142';
export const SUPPORT_ACTIVITIES_FOR_CROP_INDUSTRY_GROUP = '1151';
export const SUPPORT_ACTIVITIES_FOR_ANIMAL_INDUSTRY_GROUP = '1152';
export const SUPPORT_ACTIVITIES_FOR_FORESTRY_INDUSTRY_GROUP = '1153';
export const COAL_MINING_INDUSTRY_GROUP = '2121';
export const METAL_ORE_MINING_INDUSTRY_GROUP = '2122';
export const NONMETALLIC_MINERAL_MINING_INDUSTRY_GROUP = '2123';
export const ELECTRIC_POWER_GENERATION_INDUSTRY_GROUP = '2211';
export const NATURAL_GAS_DISTRIBUTION_INDUSTRY_GROUP = '2212';
export const RESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP = '2361';
export const NONRESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP = '2362';
export const UTILITY_SYSTEM_CONSTRUCTION_INDUSTRY_GROUP = '2371';
export const LAND_SUBDIVISION_INDUSTRY_GROUP = '2372';
export const HIGHWAY_CONSTRUCTION_INDUSTRY_GROUP = '2373';
export const OTHER_HEAVY_CONSTRUCTION_INDUSTRY_GROUP = '2379';
export const FOUNDATION_CONTRACTOR_INDUSTRY_GROUP = '2381';
export const BUILDING_EQUIPMENT_CONTRACTOR_INDUSTRY_GROUP = '2382';
export const BUILDING_FINISHING_CONTRACTOR_INDUSTRY_GROUP = '2383';
export const OTHER_SPECIALTY_TRADE_CONTRACTORS_INDUSTRY_GROUP = '2389';
export const ANIMAL_FOOD_MANUFACTURING_INDUSTRY_GROUP = '3111';
export const GRAIN_AND_OILSEED_MILLING_INDUSTRY_GROUP = '3112';
export const SUGAR_MANUFACTURING_INDUSTRY_GROUP = '3113';
export const FRUIT_PRESERVING_MANUFACTURING_INDUSTRY_GROUP = '3114';
export const DAIRY_MANUFACTURING_INDUSTRY_GROUP = '3115';
export const ANIMAL_SLAUGHTERING_INDUSTRY_GROUP = '3116';
export const SEAFOOD_PREPARATION_INDUSTRY_GROUP = '3117';
export const BAKERIES_MANUFACTURING_INDUSTRY_GROUP = '3118';
export const OTHER_FOOD_MANUFACTURING_INDUSTRY_GROUP = '3119';
export const BEVERAGE_MANUFACTURING_INDUSTRY_GROUP = '3121';
export const TOBACCO_MANUFACTURING_INDUSTRY_GROUP = '3122';
export const FIBER_YARN_MILLS_INDUSTRY_GROUP = '3131';
export const FABRIC_MILLS_INDUSTRY_GROUP = '3132';
export const TEXTILE_MILLS_INDUSTRY_GROUP = '3133';
export const TEXTILE_FURNISHING_MILLS_INDUSTRY_GROUP = '3141';
export const OTHER_TEXTILE_MILLS_INDUSTRY_GROUP = '3149';
export const APPAREL_KNITTING_MILLS_INDUSTRY_GROUP = '3151';
export const CUT_AND_SEW_APPAREL_INDUSTRY_GROUP = '3152';
export const APPAREL_ACCESSORIES_INDUSTRY_GROUP = '3159';
export const LEATHER_AND_HIDE_TANNING_INDUSTRY_GROUP = '3161';
export const FOOTWEAR_MANUFACTURING_INDUSTRY_GROUP = '3162';
export const OTHER_LEATHER_MANUFACTURING_INDUSTRY_GROUP = '3169';
export const SAWMILLS_AND_WOOD_PRESERVATION_INDUSTRY_GROUP = '3211';
export const VENEER_PLYWOOD_INDUSTRY_GROUP = '3212';
export const OTHER_WOOD_PRODUCT_INDUSTRY_GROUP = '3219';
export const PULP_PAPER_MILLS_INDUSTRY_GROUP = '3221';
export const CONVERTED_PAPER_MANUFACTURING_INDUSTRY_GROUP = '3222';
export const BASIC_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP = '3251';
export const RESIN_SYNTHETIC_RUBBER_MANUFACTURING_INDUSTRY_GROUP = '3252';
export const PESTICIDE_FERTILIZER_MANUFACTURING_INDUSTRY_GROUP = '3253';
export const PHARMACEUTICAL_AND_MEDICINE_MANUFACTURING_INDUSTRY_GROUP = '3254';
export const PAINT_COATING_MANUFACTURING_INDUSTRY_GROUP = '3255';
export const SOAP_CLEANING_COMPOUND_MANUFACTURING_INDUSTRY_GROUP = '3256';
export const OTHER_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP = '3259';
export const PLASTIC_MANUFACTURING_INDUSTRY_GROUP = '3261';
export const RUBBER_MANUFACTURING_INDUSTRY_GROUP = '3262';
export const CLAY_PRODUCT_MANUFACTURING_INDUSTRY_GROUP = '3271';
export const GLASS_MANUFACTURING_INDUSTRY_GROUP = '3272';
export const CEMENT_AND_CONCRETE_MANUFACTURING_INDUSTRY_GROUP = '3273';
export const LIME_AND_GYPSUM_MANUFACTURING_INDUSTRY_GROUP = '3274';
export const OTHER_NONMETALLIC_MANUFACTURING_INDUSTRY_GROUP = '3279';
export const IRON_AND_STEEL_MILLS_INDUSTRY_GROUP = '3311';
export const STEEL_PRODUCT_MANUFACTURING_INDUSTRY_GROUP = '3312';
export const ALUMINA_AND_ALUMINUM_PRODUCTION_INDUSTRY_GROUP = '3313';
export const NONFERROUS_METAL_PRODUCTION_INDUSTRY_GROUP = '3314';
export const FOUNDRIES_INDUSTRY_GROUP = '3315';
export const FORGING_AND_STAMPING_INDUSTRY_GROUP = '3321';
export const CUTLERY_AND_HANDTOOL_MANUFACTURING_INDUSTRY_GROUP = '3322';
export const ARCHITECTURAL_METALS_MANUFACTURING_INDUSTRY_GROUP = '3323';
export const BOILERS_TANK_MANUFACTURING_INDUSTRY_GROUP = '3324';
export const HARDWARE_MANUFACTURING_INDUSTRY_GROUP = '3325';
export const SPRING_AND_WIRE_MANUFACTURING_INDUSTRY_GROUP = '3326';
export const MACHINE_SHOPS_MANUFACTURING_INDUSTRY_GROUP = '3327';
export const COATING_ENGRAVING_HEAT_TREATING_INDUSTRY_GROUP = '3328';
export const OTHER_FABRICATED_TOOL_MANUFACTURING_INDUSTRY_GROUP = '3329';
export const AGRICULTURE_CONSTRUCTION_MANUFACTURING_INDUSTRY_GROUP = '3331';
export const INDUSTRIAL_MACHINERY_MANUFACTURING_INDUSTRY_GROUP = '3332';
export const COMMERCIAL_AND_SERVICE_INDUSTRY_MANUFACTURING_INDUSTRY_GROUP = '3333';
export const VENTILATION_HEATING_AIR_CONDITIONING_MANUFACTURING_INDUSTRY_GROUP = '3334';
export const METALWORKING_MACHINERY_MANUFACTURING_INDUSTRY_GROUP = '3335';
export const ENGINE_TURBINE_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP = '3336';
export const OTHER_GENERAL_PURPOSE_MACHINERY_MANUFACTURING_INDUSTRY_GROUP = '3339';
export const COMPUTER_MANUFACTURING_INDUSTRY_GROUP = '3341';
export const COMMUNICATION_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP = '3342';
export const AUDIO_VIDEO_MANUFACTURING_INDUSTRY_GROUP = '3343';
export const SEMICONDUCTOR_MANUFACTURING_INDUSTRY_GROUP = '3344';
export const NAVIGATIONAL_INSTRUMENTS_INDUSTRY_GROUP = '3345';
export const MANUFACTURING_AND_REPRODUCING_MAGNETIC_AND_OPTICAL_MEDIA_INDUSTRY_GROUP = '3346';
export const ELECTRIC_LIGHTING_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP = '3351';
export const HOUSEHOLD_APPLIANCE_MANUFACTURING_INDUSTRY_GROUP = '3352';
export const ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP = '3353';
export const OTHER_ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP = '3359';
export const MOTOR_VEHICLE_MANUFACTURING_INDUSTRY_GROUP = '3361';
export const VEHICLE_BODY_MANUFACTURING_INDUSTRY_GROUP = '3362';
export const VEHICLE_PARTS_MANUFACTURING_INDUSTRY_GROUP = '3363';
export const AEROSPACE_PRODUCT_MANUFACTURING_INDUSTRY_GROUP = '3364';
export const RAILROAD_MANUFACTURING_INDUSTRY_GROUP = '3365';
export const SHIP_AND_BOAT_BUILDING_INDUSTRY_GROUP = '3366';
export const OTHER_TRANSPORTATION_MANUFACTURING_INDUSTRY_GROUP = '3369';
export const HOUSEHOLD_MANUFACTURING_INDUSTRY_GROUP = '3371';
export const OFFICE_FURNITURE_MANUFACTURING_INDUSTRY_GROUP = '3372';
export const OTHER_FURNITURE_MANUFACTURING_INDUSTRY_GROUP = '3379';
export const MEDICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP = '3391';
export const OTHER_MISCELLANEOUS_MANUFACTURING_INDUSTRY_GROUP = '3399';
export const MOTOR_VEHICLE_WHOLESALERS_INDUSTRY_GROUP = '4231';
export const FURNITURE_AND_HONE_WHOLESALERS_INDUSTRY_GROUP = '4232';
export const LUMBER_WHOLESALERS_INDUSTRY_GROUP = '4233';
export const PROF_AND_COMMERCIAL_EQUIPMENT_WHOLESALERS_INDUSTRY_GROUP = '4234';
export const METAL_AND_MINERAL_WHOLESALERS_INDUSTRY_GROUP = '4235';
export const HOUSEHOLD_APPLIANCES_WHOLESALERS_INDUSTRY_GROUP = '4236';
export const HARDWARE_AND_PLUMBING_WHOLESALERS_INDUSTRY_GROUP = '4237';
export const MACHINERY_WHOLESALERS_INDUSTRY_GROUP = '4238';
export const MISCELLANEOUS_DURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP = '4239';
export const PAPER_AND_PRODUCT_WHOLESALERS_INDUSTRY_GROUP = '4241';
export const DRUGS_WHOLESALERS_INDUSTRY_GROUP = '4242';
export const APPAREL_PIECE_GOODS_WHOLESALERS_INDUSTRY_GROUP = '4243';
export const GROCERY_WHOLESALERS_INDUSTRY_GROUP = '4244';
export const FARM_PRODUCT_WHOLESALERS_INDUSTRY_GROUP = '4245';
export const CHEMICAL_AND_ALLIED_PRODUCTS_WHOLESALERS_INDUSTRY_GROUP = '4246';
export const PETROLEUM_WHOLESALERS_INDUSTRY_GROUP = '4247';
export const BEER_WINE_WHOLESALERS_INDUSTRY_GROUP = '4248';
export const MISCELLANEOUS_NONDURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP = '4249';
export const AUTO_DEALERS_INDUSTRY_GROUP = '441';
export const OTHER_MOTOR_DEALERS_INDUSTRY_GROUP = '4412';
export const AUTOMOTIVE_PARTS_INDUSTRY_GROUP = '4413';
export const BUILDING_MATERIAL_AND_SUPPLIES_DEALERS_INDUSTRY_GROUP = '4441';
export const LAWN_AND_GARDEN_EQUIPMENT_INDUSTRY_GROUP = '4442';
export const GROCERY_RETAILERS_INDUSTRY_GROUP = '4451';
export const SPECIALTY_FOOD_RETAILERS_INDUSTRY_GROUP = '4452';
export const BEER_WINE_LIQUOR_RETAILERS_INDUSTRY_GROUP = '4453';
export const FURNITURE_RETAILERS_INDUSTRY_GROUP = '4491';
export const ELECTRONICS_RETAILERS_INDUSTRY_GROUP = '4492';
export const DEPARTMENT_STORE_INDUSTRY_GROUP = '4551';
export const WAREHOUSE_CLUBS_RETAILERS_INDUSTRY_GROUP = '4552';
export const GASOLINE_STATIONS_INDUSTRY_GROUP = '4571';
export const FUEL_DEALERS_INDUSTRY_GROUP = '4572';
export const CLOTHING_RETAILERS_INDUSTRY_GROUP = '4581';
export const SHOE_RETAILERS_INDUSTRY_GROUP = '4582';
export const JEWELRY_RETAILERS_INDUSTRY_GROUP = '4583';
export const SPORTING_GOODS_RETAILERS_INDUSTRY_GROUP = '4591';
export const BOOK_RETAILERS_INDUSTRY_GROUP = '4592';
export const FLORISTS_INDUSTRY_GROUP = '4593 ';
export const OFFICE_SUPPLY_RETAILERS_INDUSTRY_GROUP = '4594';
export const USED_MERCHANDISE_INDUSTRY_GROUP = '4595';
export const OTHER_MISCELLANEOUS_INDUSTRY_GROUP = '4599';
export const SCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP = '4811';
export const NONSCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP = '4812';
export const DEEP_SEA_TRANSPORTATION_INDUSTRY_GROUP = '4831';
export const INLAND_WATER_TRANSPORTATION_INDUSTRY_GROUP = '4832';
export const GENERAL_FREIGHT_TRUCKING_INDUSTRY_GROUP = '4841';
export const SPECIALIZED_FREIGHT_TRUCKING_INDUSTRY_GROUP = '4842';
export const URBAN_TRANSIT_SYSTEMS_INDUSTRY_GROUP = '4851';
export const INTERURBAN_TRANSPORTATION_INDUSTRY_GROUP = '4852';
export const TAXI_SERVICE_INDUSTRY_GROUP = '4853';
export const SCHOOL_TRANSPORTATION_INDUSTRY_GROUP = '4854';
export const CHARTER_BUS_INDUSTRY_GROUP = '4855';
export const OTHER_TRANSIT_TRANSPORTATION_INDUSTRY_GROUP = '4859';
export const CRUDE_OIL_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP = '4861';
export const NATURAL_GAS_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP = '4862';
export const OTHER_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP = '4869';
export const SCENIC_LAND_INDUSTRY_GROUP = '4871';
export const SCENIC_WATER_INDUSTRY_GROUP = '4872';
export const SCENIC_OTHER_INDUSTRY_GROUP = '4879';
export const SUPPORT_FOR_AIR_TRANSPORTATION_INDUSTRY_GROUP = '4881';
export const SUPPORT_FOR_RAIL_TRANSPORTATION_INDUSTRY_GROUP = '4882';
export const SUPPORT_FOR_WATER_TRANSPORTATION_INDUSTRY_GROUP = '4883';
export const SUPPORT_FOR_ROAD_TRANSPORTATION_INDUSTRY_GROUP = '4884';
export const FREIGHT_TRANSPORTATION_AGREEMENT_INDUSTRY_GROUP = '4885';
export const OTHER_SUPPORT_TRANSPORTATION_INDUSTRY_GROUP = '4889';
export const COURIER_DELIVERY_INDUSTRY_GROUP = '4921';
export const LOCAL_DELIVERY_INDUSTRY_GROUP = '4922';
export const MOTION_PICTURE_INDUSTRY_GROUP = '5121';
export const SOUND_INDUSTRY_GROUP = '5122';
export const NEWSPAPER_INDUSTRY_GROUP = '5131';
export const SOFTWARE_PUBLISHERS_INDUSTRY_GROUP = '5132';
export const RADIO_AND_TELEVISION_INDUSTRY_GROUP = '5161';
export const MEDIA_STREAMING_INDUSTRY_GROUP = '5162';
export const WIRED_TELECOMMUNICATIONS_INDUSTRY_GROUP = '5171';
export const SATELLITE_TELECOMMUNICATIONS_INDUSTRY_GROUP = '5174';
export const OTHER_TELECOMMUNICATIONS_INDUSTRY_GROUP = '5178';
export const DEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP = '5221';
export const NONDEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP = '5222';
export const ACTIVITIES_RELATED_TO_CREDIT_INTERMEDIATION_INDUSTRY_GROUP = '5223';
export const COMMODITY_CONTRACTS_INDUSTRY_GROUP = '5231';
export const COMMODITY_EXCHANGES_INDUSTRY_GROUP = '5232';
export const OTHER_FINANCIAL_INVESTMENT_ACTIVITIES_INDUSTRY_GROUP = '5239';
export const INSURANCE_CARRIER_INDUSTRY_GROUP = '5241';
export const AGENCIES_BROKERAGES_INDUSTRY_GROUP = '5242';
export const INSURANCE_FUNDS_INDUSTRY_GROUP = '5251';
export const OTHER_FUNDS_FUNDS_INDUSTRY_GROUP = '5259';
export const LESSORS_OF_REAL_ESTATE_INDUSTRY_GROUP = '5311';
export const OFFICES_OF_REAL_ESTATE_INDUSTRY_GROUP = '5312';
export const ACTIVITIES_RELATED_TO_REAL_ESTATE_INDUSTRY_GROUP = '5313';
export const AUTOMOTIVE_LEASING_INDUSTRY_GROUP = '5321';
export const CONSUMER_GOODS_RENTAL_INDUSTRY_GROUP = '5322';
export const GENERAL_RENTAL_CENTERS_INDUSTRY_GROUP = '5323';
export const COMMERCIAL_MACHINERY_INDUSTRY_GROUP = '5324';
export const LEGAL_SERVICES_INDUSTRY_GROUP = '5411';
export const ACCOUNTING_SERVICES_INDUSTRY_GROUP = '5412';
export const ARCHITECTURAL_SERVICES_INDUSTRY_GROUP = '5413';
export const DESIGN_SERVICES_INDUSTRY_GROUP = '5414';
export const COMPUTER_SYSTEMS_DESIGN_SERVICES_INDUSTRY_GROUP = '5415';
export const TECHNICAL_CONSULTING_SERVICES_INDUSTRY_GROUP = '5416';
export const SCIENTIFIC_RESEARCH_SERVICES_INDUSTRY_GROUP = '5417';
export const ADVERTISING_SERVICES_INDUSTRY_GROUP = '5418';
export const OTHER_TECHNICAL_SERVICES_INDUSTRY_GROUP = '5419';
export const OFFICE_ADMINISTRATIVE_SERVICES_INDUSTRY_GROUP = '5611';
export const FACILITIES_SUPPORT_SERVICES_INDUSTRY_GROUP = '5612';
export const EMPLOYMENTS_SERVICES_INDUSTRY_GROUP = '5613';
export const BUSINESS_SUPPORT_SERVICES_INDUSTRY_GROUP = '5614';
export const RESERVATION_SERVICES_INDUSTRY_GROUP = '5615';
export const INVESTIGATION_AND_SECURITY_SERVICES_INDUSTRY_GROUP = '5616';
export const SERVICES_TO_BUILDINGS_INDUSTRY_GROUP = '5617';
export const OTHER_SUPPORT_SERVICES_INDUSTRY_GROUP = '5619';
export const WASTE_COLLECTION_INDUSTRY_GROUP = '5621';
export const WASTE_DISPOSAL_INDUSTRY_GROUP = '5622';
export const REMEDIATION_AND_OTHER_WASTE_MANAGEMENT_SERVICE_INDUSTRY_GROUP = '5629';
export const ELEMENTARY_SCHOOLS_INDUSTRY_GROUP = '6111';
export const JUNIOR_COLLEGES_INDUSTRY_GROUP = '6112';
export const PROFESSIONAL_SCHOOLS_INDUSTRY_GROUP = '6113';
export const BUSINESS_SCHOOLS_INDUSTRY_GROUP = '6114';
export const TRADE_SCHOOLS_INDUSTRY_GROUP = '6115';
export const OTHER_SCHOOLS_INDUSTRY_GROUP = '6116';
export const EDUCATIONAL_SUPPORT_SERVICES_INDUSTRY_GROUP = '6117';
export const PHYSICIANS_INDUSTRY_GROUP = '6211';
export const DENTISTS_INDUSTRY_GROUP = '6212';
export const OTHER_HEALTH_PRACTITIONERS_INDUSTRY_GROUP = '6213';
export const OUTPATIENT_CARE_CENTERS_INDUSTRY_GROUP = '6214';
export const MEDICAL_LABS_INDUSTRY_GROUP = '6215';
export const HOME_HEALTH_CARE_SERVICES_INDUSTRY_GROUP = '6216';
export const OTHER_AMBULATORY_HEALTH_CARE_INDUSTRY_GROUP = '6219';
export const GENERAL_MEDICAL_INDUSTRY_GROUP = '6221';
export const SUBSTANCE_ABUSE_HOSPITALS_INDUSTRY_GROUP = '6222';
export const SPECIALTY_HOSPITALS__INDUSTRY_GROUP = '6223';
export const NURSING_CARE_FACILITIES_INDUSTRY_GROUP = '6231';
export const RESIDENTIAL_INTELLECTUAL_INDUSTRY_GROUP = '6232';
export const RETIREMENT_COMMUNITIES_INDUSTRY_GROUP = '6233';
export const OTHER_RESIDENTIAL_CARE_INDUSTRY_GROUP = '6239';
export const INDIVIDUAL_AND_FAMILY_SERVICES_INDUSTRY_GROUP = '6241';
export const OTHER_RELIEF_SERVICES_INDUSTRY_GROUP = '6242';
export const VOCATIONAL_REHABILITATION_SERVICES_INDUSTRY_GROUP = '6243';
export const CHILD_CARE_SERVICES_INDUSTRY_GROUP = '6244';
export const PERFORMING_ARTS_COMPANIES_INDUSTRY_GROUP = '7111';
export const SPECTATOR_SPORTS_INDUSTRY_GROUP = '7112';
export const PROMOTERS_OF_PERFORMING_ARTS_INDUSTRY_GROUP = '7113';
export const ARTISTS_AGENTS_AND_MANAGERS_INDUSTRY_GROUP = '7114';
export const INDEPENDENT_ARTISTS_INDUSTRY_GROUP = '7115';
export const AMUSEMENT_PARKS_INDUSTRY_GROUP = '7131';
export const GAMBLING_INDUSTRIES_INDUSTRY_GROUP = '7132';
export const OTHER_AMUSEMENT_INDUSTRY_GROUP = '7139';
export const TRAVELER_ACCOMMODATION_INDUSTRY_GROUP = '7211';
export const RECREATIONAL_CAMPS_INDUSTRY_GROUP = '7212';
export const WORKERS_CAMPS_INDUSTRY_GROUP = '7213';
export const SPECIAL_FOOD_SERVICES_INDUSTRY_GROUP = '7223';
export const DRINKING_PLACES_INDUSTRY_GROUP = '7224';
export const OTHER_EATING_PLACES_INDUSTRY_GROUP = '7225';
export const AUTOMOTIVE_REPAIR_INDUSTRY_GROUP = '8111';
export const ELECTRONICS_REPAIR_INDUSTRY_GROUP = '8112';
export const COMMERCIAL_REPAIR_AND_MAINTENANCE_INDUSTRY_GROUP = '8113';
export const PERSONAL_GOODS_REPAIR_INDUSTRY_GROUP = '8114';
export const PERSONAL_CARE_SERVICES_INDUSTRY_GROUP = '8121';
export const DEATH_CARE_SERVICES_INDUSTRY_GROUP = '8122';
export const LAUNDRY_SERVICES_INDUSTRY_GROUP = '8123';
export const OTHER_PERSONAL_SERVICES_INDUSTRY_GROUP = '8129';
export const RELIGIOUS_ORGANIZATIONS_INDUSTRY_GROUP = '8131';
export const GRANTMAKING_INDUSTRY_GROUP = '8132';
export const SOCIAL_ADVOCACY_INDUSTRY_GROUP = '8133';
export const SOCIAL_ORGANIZATIONS_INDUSTRY_GROUP = '8134';
export const BUSINESS_LABOR_POLITICAL_INDUSTRY_GROUP = '8139';

export const INDUSTRY_GROUP_OPTIONS_UA = {
  [CROP_PRODUCTION_SUB_SECTOR]: [
    { value: OILSEED_AND_GRAIN_INDUSTRY_GROUP, label: 'Вирощування олійних та зернових культур' },
    { value: VEGETABLE_AND_MELON_INDUSTRY_GROUP, label: 'Вирощування овочів і баштанних культур' },
    { value: FRUIT_AND_TREE_NUT_INDUSTRY_GROUP, label: 'Вирощування фруктів та горіхів' },
    {
      value: GREENHOUSE_NURSERY_AND_FLORICULTURE_INDUSTRY_GROUP,
      label: 'Тепличне господарство, розсадники та квітникарство',
    },
    { value: OTHER_CROP_FARMING_INDUSTRY_GROUP, label: 'Інші види рослинництва' },
  ],
  [ANIMAL_AND_AGRICULTURE_SUB_SECTOR]: [
    { value: CATTLE_RANCHING_FARMING_INDUSTRY_GROUP, label: 'Розведення та вирощування великої рогатої худоби' },
    { value: HOD_AND_PIG_FARMING_INDUSTRY_GROUP, label: 'Свинарство' },
    { value: POULTRY_AND_EGG_INDUSTRY_GROUP, label: 'Птахівництво та виробництво яєць' },
    { value: SHEEP_AND_GOAT_INDUSTRY_GROUP, label: 'Вівчарство та козівництво' },
    { value: AQUACULTURE_INDUSTRY_GROUP, label: 'Аквакультура' },
    { value: OTHER_ANIMAL_PRODUCTION_INDUSTRY_GROUP, label: 'Інші види тваринництва' },
  ],
  [FORESTRY_AND_LOGGING_SUB_SECTOR]: [
    { value: TIMBER_TRACK_OPERATIONS_INDUSTRY_GROUP, label: 'Лісові плантації та заготівля деревини' },
    {
      value: FOREST_NURSERIES_INDUSTRY_GROUP,
      label: 'Лісові розсадники та збирання лісової продукції',
    },
    { value: LOGGING_INDUSTRY_GROUP, label: 'Лісозаготівля' },
  ],
  [FISHING_HUNTING_TRAPPING_SUB_SECTOR]: [
    { value: FISHING_INDUSTRY_GROUP, label: 'Рибальство' },
    { value: HUNTING_AND_TRAPPING_INDUSTRY_GROUP, label: 'Мисливство та відлов тварин' },
  ],
  [AGRICULTURE_SUPPORT_ACTIVITIES_SUB_SECTOR]: [
    {
      value: SUPPORT_ACTIVITIES_FOR_CROP_INDUSTRY_GROUP,
      label: 'Допоміжна діяльність у сільському та лісовому господарстві',
    },
    {
      value: SUPPORT_ACTIVITIES_FOR_ANIMAL_INDUSTRY_GROUP,
      label: 'Допоміжна діяльність у тваринництві',
    },
    {
      value: SUPPORT_ACTIVITIES_FOR_FORESTRY_INDUSTRY_GROUP,
      label: 'Допоміжна діяльність у лісовому господарстві',
    },
  ],
  [OIL_GAS_EXTRACTION_SUB_SECTOR]: [],
  [MINING_SUB_SECTOR]: [
    { value: COAL_MINING_INDUSTRY_GROUP, label: 'Видобування кам’яного та бурого вугілля' },
    { value: METAL_ORE_MINING_INDUSTRY_GROUP, label: 'Видобування металевих руд' },
    {
      value: NONMETALLIC_MINERAL_MINING_INDUSTRY_GROUP,
      label: 'Видобування неметалевих корисних копалин і розроблення кар’єрів',
    },
  ],
  [MINING_SUPPORT_ACTIVITIES_SUB_SECTOR]: [],
  [UTILITIES_SECTOR]: [
    {
      value: ELECTRIC_POWER_GENERATION_INDUSTRY_GROUP,
      label: 'Виробництво, передача та розподілення електроенергії',
    },
    {
      value: NATURAL_GAS_DISTRIBUTION_INDUSTRY_GROUP,
      label: 'Розподілення природного газу',
    },
  ],
  [BUILDING_CONSTRUCTION_SUB_SECTOR]: [
    {
      value: RESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP,
      label: 'Будівництво житлових будівель',
    },
    {
      value: NONRESIDENTIAL_BUILDING_CONSTRUCTION_INDUSTRY_GROUP,
      label: 'Будівництво нежитлових будівель',
    },
  ],
  [HEAVY_AND_CIVIL_ENGINEERING_CONSTRUCTION_SUB_SECTOR]: [
    {
      value: UTILITY_SYSTEM_CONSTRUCTION_INDUSTRY_GROUP,
      label: 'Будівництво інженерних мереж та комунальних систем',
    },
    { value: LAND_SUBDIVISION_INDUSTRY_GROUP, label: 'Розподіл та підготовка земельних ділянок' },
    {
      value: HIGHWAY_CONSTRUCTION_INDUSTRY_GROUP,
      label: 'Будівництво автошляхів, вулиць і мостів',
    },
    {
      value: OTHER_HEAVY_CONSTRUCTION_INDUSTRY_GROUP,
      label: 'Інше інженерне та промислове будівництво',
    },
  ],
  [SPECIALTY_TRADE_CONTRACTORS_SUB_SECTOR]: [
    {
      value: FOUNDATION_CONTRACTOR_INDUSTRY_GROUP,
      label: 'Підрядники з фундаментів, конструкцій та зовнішніх елементів будівель',
    },
    {
      value: BUILDING_EQUIPMENT_CONTRACTOR_INDUSTRY_GROUP,
      label: 'Підрядники з монтажу інженерного обладнання будівель',
    },
    {
      value: BUILDING_FINISHING_CONTRACTOR_INDUSTRY_GROUP,
      label: 'Підрядники з опоряджувальних робіт',
    },
    {
      value: OTHER_SPECIALTY_TRADE_CONTRACTORS_INDUSTRY_GROUP,
      label: 'Інші спеціалізовані будівельно-ремонтні підрядники',
    },
  ],
  [FOOD_MANUFACTURING_SUB_SECTOR]: [
    { value: ANIMAL_FOOD_MANUFACTURING_INDUSTRY_GROUP, label: 'Виробництво кормів для тварин' },
    { value: GRAIN_AND_OILSEED_MILLING_INDUSTRY_GROUP, label: 'Переробка зернових та олійних культур' },
    {
      value: SUGAR_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво цукру та кондитерських виробів',
    },
    {
      value: FRUIT_PRESERVING_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Консервування фруктів і овочів та виробництво спеціальних харчових продуктів',
    },
    { value: DAIRY_MANUFACTURING_INDUSTRY_GROUP, label: 'Виробництво молочних продуктів' },
    {
      value: ANIMAL_SLAUGHTERING_INDUSTRY_GROUP,
      label: 'Забій худоби та переробка м’яса',
    },
    {
      value: SEAFOOD_PREPARATION_INDUSTRY_GROUP,
      label: 'Підготовка та переробка рибної продукції',
    },
    {
      value: BAKERIES_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво хліба, хлібобулочних виробів та тортильї',
    },
    { value: OTHER_FOOD_MANUFACTURING_INDUSTRY_GROUP, label: 'Інше виробництво харчових продуктів' },
  ],
  [BEVERAGE_AND_TOBACCO_MANUFACTURING_SUB_SECTOR]: [
    { value: BEVERAGE_MANUFACTURING_INDUSTRY_GROUP, label: 'Виробництво напоїв' },
    { value: TOBACCO_MANUFACTURING_INDUSTRY_GROUP, label: 'Виробництво тютюнових виробів' },
  ],
  [TEXTILE_MILLS_SUB_SECTOR]: [
    { value: FIBER_YARN_MILLS_INDUSTRY_GROUP, label: 'Виробництво волокон, пряжі та ниток' },
    { value: FABRIC_MILLS_INDUSTRY_GROUP, label: 'Виробництво тканин' },
    {
      value: TEXTILE_MILLS_INDUSTRY_GROUP,
      label: 'Оздоблення текстилю та нанесення покриттів на тканини',
    },
  ],
  [TEXTILE_PRODUCT_MILLS_SUB_SECTOR]: [
    { value: TEXTILE_FURNISHING_MILLS_INDUSTRY_GROUP, label: 'Виробництво текстильних furnishing-виробів' },
    { value: OTHER_TEXTILE_MILLS_INDUSTRY_GROUP, label: 'Інші текстильні вироби' },
  ],
  [APPAREL_MANUFACTURING_SUB_SECTOR]: [
    { value: APPAREL_KNITTING_MILLS_INDUSTRY_GROUP, label: 'Виробництво трикотажного одягу' },
    { value: CUT_AND_SEW_APPAREL_INDUSTRY_GROUP, label: 'Пошиття одягу' },
    {
      value: APPAREL_ACCESSORIES_INDUSTRY_GROUP,
      label: 'Виробництво аксесуарів та іншого одягу',
    },
  ],
  [LEATHER_AND_ALLIED_PRODUCT_MANUFACTURING_SUB_SECTOR]: [
    {
      value: LEATHER_AND_HIDE_TANNING_INDUSTRY_GROUP,
      label: 'Вичинка та оздоблення шкіри та хутра',
    },
    { value: FOOTWEAR_MANUFACTURING_INDUSTRY_GROUP, label: 'Виробництво взуття' },
    {
      value: OTHER_LEATHER_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Інші шкіряні та споріднені вироби',
    },
  ],
  [WOOD_PRODUCT_MANUFACTURING_SUB_SECTOR]: [
    {
      value: SAWMILLS_AND_WOOD_PRESERVATION_INDUSTRY_GROUP,
      label: 'Лісопильне виробництво та просочування деревини',
    },
    {
      value: VENEER_PLYWOOD_INDUSTRY_GROUP,
      label: 'Виробництво фанери, шпону та інженерної деревини',
    },
    { value: OTHER_WOOD_PRODUCT_INDUSTRY_GROUP, label: 'Інші вироби з деревини' },
  ],
  [PAPER_MANUFACTURING_SUB_SECTOR]: [
    {
      value: PULP_PAPER_MILLS_INDUSTRY_GROUP,
      label: 'Целюлозно-паперові та картонні комбінати',
    },
    {
      value: CONVERTED_PAPER_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво виробів із паперу та картону',
    },
  ],
  [PRINTING_MANUFACTURING_SUB_SECTOR]: [],
  [PETROLEUM_AND_COAL_MANUFACTURING_SUB_SECTOR]: [],
  [CHEMICAL_MANUFACTURING_SUB_SECTOR]: [
    { value: BASIC_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP, label: 'Виробництво базових хімічних речовин' },
    {
      value: RESIN_SYNTHETIC_RUBBER_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво смол, синтетичного каучуку та синтетичних волокон',
    },
    {
      value: PESTICIDE_FERTILIZER_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво пестицидів, добрив та інших агрохімікатів',
    },
    {
      value: PHARMACEUTICAL_AND_MEDICINE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво фармацевтичних препаратів та медичних засобів',
    },
    {
      value: PAINT_COATING_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво фарб, лаків та клеїв',
    },
    {
      value: SOAP_CLEANING_COMPOUND_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво мила, мийних засобів та засобів особистої гігієни',
    },
    {
      value: OTHER_CHEMICAL_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Інші хімічні продукти та препарати',
    },
  ],
  [PLASTICS_AND_RUBBER_MANUFACTURING_SUB_SECTOR]: [
    { value: PLASTIC_MANUFACTURING_INDUSTRY_GROUP, label: 'Вироби з пластмас' },
    { value: RUBBER_MANUFACTURING_INDUSTRY_GROUP, label: 'Вироби з гуми' },
  ],
  [NONMETALLIC_MINERAL_MANUFACTURING_SUB_SECTOR]: [
    {
      value: CLAY_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво глиняних виробів та вогнетривів',
    },
    {
      value: GLASS_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво скла та скляних виробів',
    },
    {
      value: CEMENT_AND_CONCRETE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво цементу та бетонних виробів',
    },
    {
      value: LIME_AND_GYPSUM_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво вапна та гіпсових виробів',
    },
    {
      value: OTHER_NONMETALLIC_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Інші неметалеві мінеральні продукти',
    },
  ],
  [PRIMARY_METAL_MANUFACTURING_SUB_SECTOR]: [
    {
      value: IRON_AND_STEEL_MILLS_INDUSTRY_GROUP,
      label: 'Виробництво чавуну, сталі та феросплавів',
    },
    {
      value: STEEL_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво сталевих виробів із придбаної сталі',
    },
    {
      value: ALUMINA_AND_ALUMINUM_PRODUCTION_INDUSTRY_GROUP,
      label: 'Виробництво глинозему та продукції з алюмінію',
    },
    {
      value: NONFERROUS_METAL_PRODUCTION_INDUSTRY_GROUP,
      label: 'Виробництво та переробка кольорових металів (крім алюмінію)',
    },
    { value: FOUNDRIES_INDUSTRY_GROUP, label: 'Ливарні виробництва' },
  ],
  [FABRICATED_METAL_MANUFACTURING_SUB_SECTOR]: [
    { value: FORGING_AND_STAMPING_INDUSTRY_GROUP, label: 'Кування та штампування металів' },
    {
      value: CUTLERY_AND_HANDTOOL_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво столових приборів та ручного інструменту',
    },
    {
      value: ARCHITECTURAL_METALS_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво архітектурних та конструкційних металевих виробів',
    },
    {
      value: BOILERS_TANK_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво котлів, резервуарів та металевих контейнерів',
    },
    { value: HARDWARE_MANUFACTURING_INDUSTRY_GROUP, label: 'Виробництво металевого кріплення та фурнітури' },
    {
      value: SPRING_AND_WIRE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво пружин та дротяних виробів',
    },
    {
      value: MACHINE_SHOPS_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Металообробні майстерні та виробництво кріпильних виробів',
    },
    {
      value: COATING_ENGRAVING_HEAT_TREATING_INDUSTRY_GROUP,
      label: 'Покриття, гравірування, термообробка та споріднені послуги',
    },
    {
      value: OTHER_FABRICATED_TOOL_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Інші металовироби та металообробка',
    },
  ],
  [MACHINERY_MANUFACTURING_SUB_SECTOR]: [
    {
      value: AGRICULTURE_CONSTRUCTION_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво сільськогосподарської, будівельної та гірничої техніки',
    },
    {
      value: INDUSTRIAL_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво промислового обладнання',
    },
    {
      value: COMMERCIAL_AND_SERVICE_INDUSTRY_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво комерційного та сервісного обладнання',
    },
    {
      value: VENTILATION_HEATING_AIR_CONDITIONING_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво вентиляційного, опалювального та холодильного обладнання',
    },
    {
      value: METALWORKING_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво металорізального та металургійного обладнання',
    },
    {
      value: ENGINE_TURBINE_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво двигунів, турбін та передавального обладнання',
    },
    {
      value: OTHER_GENERAL_PURPOSE_MACHINERY_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Інше загальнопромислове обладнання',
    },
  ],
  [COMPUTER_AND_ELECTRONIC_MANUFACTURING_SUB_SECTOR]: [
    {
      value: COMPUTER_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво комп’ютерів та периферійного обладнання',
    },
    {
      value: COMMUNICATION_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво телекомунікаційного обладнання',
    },
    {
      value: AUDIO_VIDEO_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво аудіо- та відеообладнання',
    },
    {
      value: SEMICONDUCTOR_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво напівпровідників та інших електронних компонентів',
    },
    {
      value: NAVIGATIONAL_INSTRUMENTS_INDUSTRY_GROUP,
      label: 'Виробництво навігаційних, вимірювальних та медичних приладів',
    },
    {
      value: MANUFACTURING_AND_REPRODUCING_MAGNETIC_AND_OPTICAL_MEDIA_INDUSTRY_GROUP,
      label: 'Виробництво та тиражування магнітних і оптичних носіїв',
    },
  ],
  [ELECTRICAL_EQUIPMENT_MANUFACTURING_SUB_SECTOR]: [
    {
      value: ELECTRIC_LIGHTING_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво електроосвітлювального обладнання',
    },
    {
      value: HOUSEHOLD_APPLIANCE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво побутової техніки',
    },
    {
      value: ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво електричного обладнання',
    },
    {
      value: OTHER_ELECTRICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Інше електрообладнання та електрокомпоненти',
    },
  ],
  [TRANSPORTATION_EQUIPMENT_MANUFACTURING_SUB_SECTOR]: [
    { value: MOTOR_VEHICLE_MANUFACTURING_INDUSTRY_GROUP, label: 'Виробництво автотранспортних засобів' },
    {
      value: VEHICLE_BODY_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво кузовів автотранспортних засобів та причепів',
    },
    {
      value: VEHICLE_PARTS_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво автозапчастин та комплектуючих',
    },
    {
      value: AEROSPACE_PRODUCT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво авіаційно-космічної техніки та деталей',
    },
    {
      value: RAILROAD_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво рухомого складу залізниць',
    },
    {
      value: SHIP_AND_BOAT_BUILDING_INDUSTRY_GROUP,
      label: 'Суднобудування та будівництво човнів',
    },
    {
      value: OTHER_TRANSPORTATION_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Інше транспортне обладнання',
    },
  ],
  [FURNITURE_MANUFACTURING_SUB_SECTOR]: [
    {
      value: HOUSEHOLD_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво меблів для дому, закладів та кухонь',
    },
    {
      value: OFFICE_FURNITURE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво офісних меблів та меблевих конструкцій',
    },
    {
      value: OTHER_FURNITURE_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво інших меблевих виробів',
    },
  ],
  [MISCELLANEOUS_MANUFACTURING_SUB_SECTOR]: [
    {
      value: MEDICAL_EQUIPMENT_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Виробництво медичного обладнання та приладдя',
    },
    {
      value: OTHER_MISCELLANEOUS_MANUFACTURING_INDUSTRY_GROUP,
      label: 'Інші різновиди виробничої діяльності',
    },
  ],
  [DURABLE_GOODS_SUB_SECTOR]: [
    {
      value: MOTOR_VEHICLE_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Оптова торгівля автотранспортом, деталями та приладдям',
    },
    {
      value: FURNITURE_AND_HONE_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Оптова торгівля меблями та товарами для дому',
    },
    {
      value: LUMBER_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Оптова торгівля лісоматеріалами та будівельними матеріалами',
    },
    {
      value: PROF_AND_COMMERCIAL_EQUIPMENT_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Оптова торгівля професійним та комерційним обладнанням',
    },
    {
      value: METAL_AND_MINERAL_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Оптова торгівля металами та мінералами (крім нафтопродуктів)',
    },
    {
      value: HOUSEHOLD_APPLIANCES_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Оптова торгівля побутовою технікою та електронікою',
    },
    {
      value: HARDWARE_AND_PLUMBING_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Оптова торгівля кріпленням, сантехнікою та обладнанням для опалення',
    },
    {
      value: MACHINERY_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Оптова торгівля машинами, обладнанням і приладдям',
    },
    {
      value: MISCELLANEOUS_DURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Оптова торгівля іншими довгостроковими товарами',
    },
  ],
  [NONDURABLE_GOODS_SUB_SECTOR]: [
    {
      value: PAPER_AND_PRODUCT_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Оптова торгівля папером та виробами з паперу',
    },
    {
      value: DRUGS_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Оптова торгівля лікарськими засобами та аптечним асортиментом',
    },
    {
      value: APPAREL_PIECE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Оптова торгівля одягом, тканинами та фурнітурою',
    },
    {
      value: GROCERY_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Оптова торгівля продовольчими товарами',
    },
    {
      value: FARM_PRODUCT_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Оптова торгівля сільськогосподарською сировиною',
    },
    {
      value: CHEMICAL_AND_ALLIED_PRODUCTS_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Оптова торгівля хімічними та спорідненими продуктами',
    },
    {
      value: PETROLEUM_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Оптова торгівля нафтопродуктами',
    },
    {
      value: BEER_WINE_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Оптова торгівля пивом, вином та міцними напоями',
    },
    {
      value: MISCELLANEOUS_NONDURABLE_GOODS_WHOLESALERS_INDUSTRY_GROUP,
      label: 'Оптова торгівля іншими недовгостроковими товарами',
    },
  ],
  [AGENTS_AND_BROKERS_SUB_SECTOR]: [],
  [MOTOR_VEHICLE_AND_PARTS_DEALERS_SUB_SECTOR]: [
    { value: AUTO_DEALERS_INDUSTRY_GROUP, label: 'Автосалони та дилери нових і вживаних авто' },
    { value: OTHER_MOTOR_DEALERS_INDUSTRY_GROUP, label: 'Інші дилери моторизованого транспорту' },
    {
      value: AUTOMOTIVE_PARTS_INDUSTRY_GROUP,
      label: 'Роздрібна торгівля автозапчастинами, аксесуарами та шинами',
    },
  ],

  [BUILDING_MATERIAL_DEALERS_SUB_SECTOR]: [
    {
      value: BUILDING_MATERIAL_AND_SUPPLIES_DEALERS_INDUSTRY_GROUP,
      label: 'Роздрібна торгівля будівельними матеріалами та супутніми товарами',
    },
    {
      value: LAWN_AND_GARDEN_EQUIPMENT_INDUSTRY_GROUP,
      label: 'Роздрібна торгівля обладнанням і товарами для саду та газону',
    },
  ],
  [FOOD_RETAILERS_SUB_SECTOR]: [
    {
      value: GROCERY_RETAILERS_INDUSTRY_GROUP,
      label: 'Роздрібна торгівля продуктами та товарами щоденного попиту (включно з магазинами крокової доступності)',
    },
    {
      value: SPECIALTY_FOOD_RETAILERS_INDUSTRY_GROUP,
      label: 'Спеціалізовані продуктові роздрібні магазини',
    },
    {
      value: BEER_WINE_LIQUOR_RETAILERS_INDUSTRY_GROUP,
      label: 'Роздрібна торгівля пивом, вином та міцними алкогольними напоями',
    },
  ],
  [FURNITURE_RETAILERS_SUB_SECTOR]: [
    {
      value: FURNITURE_RETAILERS_INDUSTRY_GROUP,
      label: 'Роздрібна торгівля меблями та товарами для дому',
    },
    {
      value: ELECTRONICS_RETAILERS_INDUSTRY_GROUP,
      label: 'Роздрібна торгівля електронікою та побутовою технікою',
    },
  ],
  [MERCHANDISE_RETAILERS_SUB_SECTOR]: [
    { value: DEPARTMENT_STORE_INDUSTRY_GROUP, label: 'Універмаги' },
    {
      value: WAREHOUSE_CLUBS_RETAILERS_INDUSTRY_GROUP,
      label: 'Оптові клуби, гіпермаркети та інші магазини загального асортименту',
    },
  ],
  [HEALTH_RETAILERS_SUB_SECTOR]: [],
  [GASOLINE_DEALERS_SUB_SECTOR]: [
    { value: GASOLINE_STATIONS_INDUSTRY_GROUP, label: 'Автозаправні станції' },
    { value: FUEL_DEALERS_INDUSTRY_GROUP, label: 'Паливні компанії та постачальники палива' },
  ],
  [CLOTHING_RETAILERS_SUB_SECTOR]: [
    {
      value: CLOTHING_RETAILERS_INDUSTRY_GROUP,
      label: 'Роздрібна торгівля одягом та аксесуарами',
    },
    { value: SHOE_RETAILERS_INDUSTRY_GROUP, label: 'Магазини взуття' },
    {
      value: JEWELRY_RETAILERS_INDUSTRY_GROUP,
      label: 'Магазини ювелірних виробів, валіз та виробів зі шкіри',
    },
  ],
  [SPORTING_GOODS_RETAILERS_SUB_SECTOR]: [
    {
      value: SPORTING_GOODS_RETAILERS_INDUSTRY_GROUP,
      label: 'Роздрібна торгівля спортивними товарами, товарами для хобі та музичними інструментами',
    },
    {
      value: BOOK_RETAILERS_INDUSTRY_GROUP,
      label: 'Книгарні та роздрібна торгівля періодикою',
    },
    { value: FLORISTS_INDUSTRY_GROUP, label: 'Квіткові магазини' },
    {
      value: OFFICE_SUPPLY_RETAILERS_INDUSTRY_GROUP,
      label: 'Роздрібна торгівля канцелярськими товарами, папіром та подарунками',
    },
    { value: USED_MERCHANDISE_INDUSTRY_GROUP, label: 'Магазини вживаних товарів' },
    {
      value: OTHER_MISCELLANEOUS_INDUSTRY_GROUP,
      label: 'Інші спеціалізовані роздрібні магазини',
    },
  ],
  [AIR_TRANSPORTATION_SUB_SECTOR]: [
    {
      value: SCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Регулярні пасажирські та вантажні авіаперевезення',
    },
    {
      value: NONSCHEDULED_AIR_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Нерегулярні (чартерні) авіаперевезення',
    },
  ],
  [RAIL_TRANSPORTATION_SUB_SECTOR]: [],
  [WATER_TRANSPORTATION_SUB_SECTOR]: [
    {
      value: DEEP_SEA_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Морські, прибережні та великі озерні вантажні й пасажирські перевезення',
    },
    {
      value: INLAND_WATER_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Внутрішні водні перевезення',
    },
  ],
  [TRUCK_TRANSPORTATION_SUB_SECTOR]: [
    { value: GENERAL_FREIGHT_TRUCKING_INDUSTRY_GROUP, label: 'Автомобільні вантажні перевезення (загальні вантажі)' },
    {
      value: SPECIALIZED_FREIGHT_TRUCKING_INDUSTRY_GROUP,
      label: 'Автомобільні вантажні перевезення спеціалізованих вантажів',
    },
  ],
  [TRANSIT_TRANSPORTATION_SUB_SECTOR]: [
    { value: URBAN_TRANSIT_SYSTEMS_INDUSTRY_GROUP, label: 'Міський громадський транспорт' },
    {
      value: INTERURBAN_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Міжміські та сільські автобусні перевезення',
    },
    { value: TAXI_SERVICE_INDUSTRY_GROUP, label: 'Таксі та послуги перевезення з водієм (лімузини, ride-hailing)' },
    {
      value: SCHOOL_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Перевезення школярів та працівників компаній',
    },
    { value: CHARTER_BUS_INDUSTRY_GROUP, label: 'Чартерні автобусні перевезення' },
    {
      value: OTHER_TRANSIT_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Інший наземний пасажирський транспорт',
    },
  ],
  [PIPELINE_TRANSPORTATION_SUB_SECTOR]: [
    {
      value: CRUDE_OIL_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Трубопровідний транспорт сирої нафти',
    },
    {
      value: NATURAL_GAS_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Трубопровідний транспорт природного газу',
    },
    { value: OTHER_PIPELINE_TRANSPORTATION_INDUSTRY_GROUP, label: 'Інший трубопровідний транспорт' },
  ],
  [SCENIC_TRANSPORTATION_SUB_SECTOR]: [
    {
      value: SCENIC_LAND_INDUSTRY_GROUP,
      label: 'Екскурсійні та туристичні перевезення сушею',
    },
    {
      value: SCENIC_WATER_INDUSTRY_GROUP,
      label: 'Екскурсійні та туристичні водні перевезення',
    },
    {
      value: SCENIC_OTHER_INDUSTRY_GROUP,
      label: 'Інші екскурсійні та оглядові види транспорту',
    },
  ],
  [SUPPORT_ACTIVITIES_FOR_TRANSPORTATION_SUB_SECTOR]: [
    {
      value: SUPPORT_FOR_AIR_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Допоміжна діяльність у сфері авіаційного транспорту',
    },
    {
      value: SUPPORT_FOR_RAIL_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Допоміжна діяльність у сфері залізничного транспорту',
    },
    {
      value: SUPPORT_FOR_WATER_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Допоміжна діяльність у сфері водного транспорту',
    },
    {
      value: SUPPORT_FOR_ROAD_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Допоміжна діяльність у сфері автомобільного транспорту',
    },
    {
      value: FREIGHT_TRANSPORTATION_AGREEMENT_INDUSTRY_GROUP,
      label: 'Організація та посередництво у вантажних перевезеннях (експедиція, логістика)',
    },
    {
      value: OTHER_SUPPORT_TRANSPORTATION_INDUSTRY_GROUP,
      label: 'Інша допоміжна діяльність у сфері транспорту',
    },
  ],
  [POSTAL_SERVICE_SUB_SECTOR]: [],
  [COURIERS_SUB_SECTOR]: [
    { value: COURIER_DELIVERY_INDUSTRY_GROUP, label: 'Кур’єрські та експрес-доставки' },
    { value: LOCAL_DELIVERY_INDUSTRY_GROUP, label: 'Місцеві кур’єрські служби та доставка' },
  ],
  [WAREHOUSING_AND_STORAGE_SUB_SECTOR]: [],
  [MOTION_PIC_INDUSTRIES_SUB_SECTOR]: [
    { value: MOTION_PICTURE_INDUSTRY_GROUP, label: 'Виробництво та показ кіно- й відеопродукції' },
    { value: SOUND_INDUSTRY_GROUP, label: 'Звуkozапис та суміжні індустрії' },
  ],
  [PUBLISHING_INDUSTRIES_SUB_SECTOR]: [
    {
      value: NEWSPAPER_INDUSTRY_GROUP,
      label: 'Видавництво газет, журналів, книжок та довідників',
    },
    { value: SOFTWARE_PUBLISHERS_INDUSTRY_GROUP, label: 'Видавництво програмного забезпечення' },
  ],
  [BROADCASTING_PROVIDER_SUB_SECTOR]: [
    {
      value: RADIO_AND_TELEVISION_INDUSTRY_GROUP,
      label: 'Радіо- та телевізійне мовлення',
    },
    {
      value: MEDIA_STREAMING_INDUSTRY_GROUP,
      label: 'Медіа-стримінгові платформи, соціальні мережі та інші медіамережі й контент-провайдери',
    },
  ],
  [TELECOMMUNICATION_SUB_SECTOR]: [
    {
      value: WIRED_TELECOMMUNICATIONS_INDUSTRY_GROUP,
      label: 'Провідний і безпровідний (крім супутникового) зв’язок',
    },
    { value: SATELLITE_TELECOMMUNICATIONS_INDUSTRY_GROUP, label: 'Супутниковий зв’язок' },
    { value: OTHER_TELECOMMUNICATIONS_INDUSTRY_GROUP, label: 'Інші телекомунікаційні послуги' },
  ],
  [COMPUTING_INFRASTRUCTURE_SUB_SECTOR]: [],
  [WEB_SEARCH_PORTALS_SUB_SECTOR]: [],
  [MONETARY_BANK_SUB_SECTOR]: [],
  [CREDIT_INTERMEDIATION_SUB_SECTOR]: [
    {
      value: DEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP,
      label: 'Депозитно-кредитні установи (банки та подібні організації)',
    },
    {
      value: NONDEPOSITORY_INTERMEDIATION_INDUSTRY_GROUP,
      label: 'Недепозитні кредитні установи',
    },
    {
      value: ACTIVITIES_RELATED_TO_CREDIT_INTERMEDIATION_INDUSTRY_GROUP,
      label: 'Діяльність, пов’язана з кредитним посередництвом',
    },
  ],
  [SECURITIES_COMMODITY_SUB_SECTOR]: [
    {
      value: COMMODITY_CONTRACTS_INDUSTRY_GROUP,
      label: 'Посередництво з цінними паперами та товарними контрактами',
    },
    {
      value: COMMODITY_EXCHANGES_INDUSTRY_GROUP,
      label: 'Фондові та товарні біржі',
    },
    {
      value: OTHER_FINANCIAL_INVESTMENT_ACTIVITIES_INDUSTRY_GROUP,
      label: 'Інші види фінансово-інвестиційної діяльності',
    },
  ],
  [INSURANCE_CARRIERS_SUB_SECTOR]: [
    { value: INSURANCE_CARRIER_INDUSTRY_GROUP, label: 'Страхові компанії' },
    {
      value: AGENCIES_BROKERAGES_INDUSTRY_GROUP,
      label: 'Страхові агенції, брокери та інша пов’язана діяльність',
    },
  ],
  [FUNDS_TRUSTS_SUB_SECTOR]: [
    {
      value: INSURANCE_FUNDS_INDUSTRY_GROUP,
      label: 'Страхові та фонди соціальних виплат (пенсійні, медичні тощо)',
    },
    {
      value: OTHER_FUNDS_FUNDS_INDUSTRY_GROUP,
      label: 'Інші інвестиційні фонди та пулові структури',
    },
  ],
  [REAL_ESTATE_SUB_SECTOR]: [
    { value: LESSORS_OF_REAL_ESTATE_INDUSTRY_GROUP, label: 'Орендодавці нерухомості' },
    {
      value: OFFICES_OF_REAL_ESTATE_INDUSTRY_GROUP,
      label: 'Агентства та брокери з операцій з нерухомістю',
    },
    {
      value: ACTIVITIES_RELATED_TO_REAL_ESTATE_INDUSTRY_GROUP,
      label: 'Інша діяльність, пов’язана з нерухомістю',
    },
  ],
  [RENTAL_AND_LEASING_SUB_SECTOR]: [
    {
      value: AUTOMOTIVE_LEASING_INDUSTRY_GROUP,
      label: 'Оренда та лізинг автотранспорту',
    },
    {
      value: CONSUMER_GOODS_RENTAL_INDUSTRY_GROUP,
      label: 'Оренда товарів для особистого користування',
    },
    {
      value: GENERAL_RENTAL_CENTERS_INDUSTRY_GROUP,
      label: 'Пункти загальної оренди обладнання та товарів',
    },
    {
      value: COMMERCIAL_MACHINERY_INDUSTRY_GROUP,
      label: 'Оренда та лізинг комерційних і промислових машин та обладнання',
    },
  ],
  [LESSORS_OF_NONFINACIAL_ASSETS_SUB_SECTOR]: [],
  [SCIENTIFIC_SERVICES_SECTOR]: [
    { value: LEGAL_SERVICES_INDUSTRY_GROUP, label: 'Юридичні послуги' },
    {
      value: ACCOUNTING_SERVICES_INDUSTRY_GROUP,
      label: 'Бухгалтерські послуги, підготовка звітності, податкова та платіжна обробка',
    },
    {
      value: ARCHITECTURAL_SERVICES_INDUSTRY_GROUP,
      label: 'Архітектурні, інженерні та споріднені послуги',
    },
    { value: DESIGN_SERVICES_INDUSTRY_GROUP, label: 'Спеціалізовані дизайнерські послуги' },
    {
      value: COMPUTER_SYSTEMS_DESIGN_SERVICES_INDUSTRY_GROUP,
      label: 'Розробка комп’ютерних систем та супутні ІТ-послуги',
    },
    {
      value: TECHNICAL_CONSULTING_SERVICES_INDUSTRY_GROUP,
      label: 'Консалтинг у сфері менеджменту, науки та техніки',
    },
    {
      value: SCIENTIFIC_RESEARCH_SERVICES_INDUSTRY_GROUP,
      label: 'Науково-дослідні та дослідно-конструкторські роботи',
    },
    {
      value: ADVERTISING_SERVICES_INDUSTRY_GROUP,
      label: 'Реклама, зв’язки з громадськістю та пов’язані послуги',
    },
    {
      value: OTHER_TECHNICAL_SERVICES_INDUSTRY_GROUP,
      label: 'Інші професійні, наукові та технічні послуги',
    },
  ],
  [ADMINISTRATIVE_SERVICE_SUB_SECTOR]: [
    { value: OFFICE_ADMINISTRATIVE_SERVICES_INDUSTRY_GROUP, label: 'Офісне адміністрування' },
    {
      value: FACILITIES_SUPPORT_SERVICES_INDUSTRY_GROUP,
      label: 'Комплексне обслуговування будівель та об’єктів',
    },
    { value: EMPLOYMENTS_SERVICES_INDUSTRY_GROUP, label: 'Послуги з працевлаштування та підбору персоналу' },
    { value: BUSINESS_SUPPORT_SERVICES_INDUSTRY_GROUP, label: 'Бізнес-підтримка та бек-офісні послуги' },
    {
      value: RESERVATION_SERVICES_INDUSTRY_GROUP,
      label: 'Туристичні агентства та послуги бронювання подорожей',
    },
    {
      value: INVESTIGATION_AND_SECURITY_SERVICES_INDUSTRY_GROUP,
      label: 'Охоронні, детективні та інші безпекові послуги',
    },
    {
      value: SERVICES_TO_BUILDINGS_INDUSTRY_GROUP,
      label: 'Послуги з догляду за будівлями та прибудинковими територіями',
    },
    {
      value: OTHER_SUPPORT_SERVICES_INDUSTRY_GROUP,
      label: 'Інші допоміжні бізнес-послуги',
    },
  ],
  [WASTE_MANAGEMENT_SUB_SECTOR]: [
    { value: WASTE_COLLECTION_INDUSTRY_GROUP, label: 'Збирання відходів' },
    {
      value: WASTE_DISPOSAL_INDUSTRY_GROUP,
      label: 'Оброблення та видалення відходів',
    },
    {
      value: REMEDIATION_AND_OTHER_WASTE_MANAGEMENT_SERVICE_INDUSTRY_GROUP,
      label: 'Рекультивація та інші послуги з управління відходами',
    },
  ],
  [EDUCATIONAL_SERVICES_SUB_SECTOR]: [
    {
      value: ELEMENTARY_SCHOOLS_INDUSTRY_GROUP,
      label: 'Початкові та середні школи',
    },
    { value: JUNIOR_COLLEGES_INDUSTRY_GROUP, label: 'Коледжі та молодші спеціалісти' },
    {
      value: PROFESSIONAL_SCHOOLS_INDUSTRY_GROUP,
      label: 'Університети, коледжі та професійні навчальні заклади',
    },
    {
      value: BUSINESS_SCHOOLS_INDUSTRY_GROUP,
      label: 'Бізнес-школи та навчання з комп’ютерних і управлінських дисциплін',
    },
    {
      value: TRADE_SCHOOLS_INDUSTRY_GROUP,
      label: 'Технічні та професійно-технічні училища',
    },
    { value: OTHER_SCHOOLS_INDUSTRY_GROUP, label: 'Інші освітні програми та курси' },
    {
      value: EDUCATIONAL_SUPPORT_SERVICES_INDUSTRY_GROUP,
      label: 'Допоміжні послуги в освіті',
    },
  ],
  [AMBULATORY_CARE_SUB_SECTOR]: [
    { value: PHYSICIANS_INDUSTRY_GROUP, label: 'Лікарські кабінети та практики' },
    { value: DENTISTS_INDUSTRY_GROUP, label: 'Стоматологічні кабінети та клініки' },
    {
      value: OTHER_HEALTH_PRACTITIONERS_INDUSTRY_GROUP,
      label: 'Кабінети інших медичних та оздоровчих фахівців',
    },
    {
      value: OUTPATIENT_CARE_CENTERS_INDUSTRY_GROUP,
      label: 'Амбулаторні медичні центри',
    },
    {
      value: MEDICAL_LABS_INDUSTRY_GROUP,
      label: 'Медичні лабораторії та центри діагностики',
    },
    {
      value: HOME_HEALTH_CARE_SERVICES_INDUSTRY_GROUP,
      label: 'Домашній догляд та медичні послуги вдома',
    },
    {
      value: OTHER_AMBULATORY_HEALTH_CARE_INDUSTRY_GROUP,
      label: 'Інші амбулаторні медичні послуги',
    },
  ],
  [HOSPITALS_SUB_SECTOR]: [
    {
      value: GENERAL_MEDICAL_INDUSTRY_GROUP,
      label: 'Загальні медичні та хірургічні лікарні',
    },
    {
      value: SUBSTANCE_ABUSE_HOSPITALS_INDUSTRY_GROUP,
      label: 'Психіатричні лікарні та центри лікування залежностей',
    },
    {
      value: SPECIALTY_HOSPITALS__INDUSTRY_GROUP,
      label: 'Спеціалізовані лікарні (крім психіатричних та наркологічних)',
    },
  ],
  [NURSING_FACILITIES_SUB_SECTOR]: [
    {
      value: NURSING_CARE_FACILITIES_INDUSTRY_GROUP,
      label: 'Заклади сестринського догляду та догляду за літніми людьми',
    },
    {
      value: RESIDENTIAL_INTELLECTUAL_INDUSTRY_GROUP,
      label: 'Житлові заклади для осіб з інтелектуальними порушеннями, ментальними розладами та залежностями',
    },
    {
      value: RETIREMENT_COMMUNITIES_INDUSTRY_GROUP,
      label: 'Будинки для літніх людей з безперервним доглядом та заклади підтриманого проживання',
    },
    {
      value: OTHER_RESIDENTIAL_CARE_INDUSTRY_GROUP,
      label: 'Інші заклади тривалого проживання з доглядом',
    },
  ],
  [SOCIAL_ASSISTANCE_SUB_SECTOR]: [
    {
      value: INDIVIDUAL_AND_FAMILY_SERVICES_INDUSTRY_GROUP,
      label: 'Соціальні послуги для окремих осіб та сімей',
    },
    {
      value: OTHER_RELIEF_SERVICES_INDUSTRY_GROUP,
      label: 'Громадське харчування, житло та екстрена допомога',
    },
    {
      value: VOCATIONAL_REHABILITATION_SERVICES_INDUSTRY_GROUP,
      label: 'Професійна реабілітація',
    },
    { value: CHILD_CARE_SERVICES_INDUSTRY_GROUP, label: 'Послуги з догляду за дітьми' },
  ],
  [PERFORMING_ARTS_SUB_SECTOR]: [
    {
      value: PERFORMING_ARTS_COMPANIES_INDUSTRY_GROUP,
      label: 'Театральні, танцювальні, музичні та інші сценічні колективи',
    },
    { value: SPECTATOR_SPORTS_INDUSTRY_GROUP, label: 'Глядацькі види спорту' },
    {
      value: PROMOTERS_OF_PERFORMING_ARTS_INDUSTRY_GROUP,
      label: 'Організатори концертів, спортивних та подібних заходів',
    },
    {
      value: ARTISTS_AGENTS_AND_MANAGERS_INDUSTRY_GROUP,
      label: 'Агенти та менеджери артистів, спортсменів, публічних осіб',
    },
    {
      value: INDEPENDENT_ARTISTS_INDUSTRY_GROUP,
      label: 'Незалежні артисти, письменники та виконавці',
    },
  ],
  [MUSEUMS_SUB_SECTOR]: [],
  [AMUSEMENT_INDUSTRY_SUB_SECTOR]: [
    {
      value: AMUSEMENT_PARKS_INDUSTRY_GROUP,
      label: 'Парки розваг та ігрові автомати',
    },
    { value: GAMBLING_INDUSTRIES_INDUSTRY_GROUP, label: 'Гральний бізнес' },
    {
      value: OTHER_AMUSEMENT_INDUSTRY_GROUP,
      label: 'Інші заклади відпочинку та розваг',
    },
  ],
  [ACCOMMODATION_SUB_SECTOR]: [
    {
      value: TRAVELER_ACCOMMODATION_INDUSTRY_GROUP,
      label: 'Готелі, мотелі та інші місця тимчасового проживання',
    },
    {
      value: RECREATIONAL_CAMPS_INDUSTRY_GROUP,
      label: 'Кемпінги, парки для автодомів та рекреаційні табори',
    },
    {
      value: WORKERS_CAMPS_INDUSTRY_GROUP,
      label: 'Гуртожитки, пансіони та житло для працівників',
    },
  ],
  [FOOD_SERVICES_AND_DRINKING_PLACES_SUB_SECTOR]: [
    {
      value: SPECIAL_FOOD_SERVICES_INDUSTRY_GROUP,
      label: 'Спеціалізовані послуги харчування (кейтеринг, їдальні тощо)',
    },
    {
      value: DRINKING_PLACES_INDUSTRY_GROUP,
      label: 'Заклади, що подають алкогольні напої (бари, паби тощо)',
    },
    {
      value: OTHER_EATING_PLACES_INDUSTRY_GROUP,
      label: 'Ресторани, кафе, заклади швидкого харчування та інші заклади харчування',
    },
  ],
  [REPAIR_AND_MAINTENANCE_SUB_SECTOR]: [
    {
      value: AUTOMOTIVE_REPAIR_INDUSTRY_GROUP,
      label: 'Ремонт та обслуговування автотранспорту',
    },
    {
      value: ELECTRONICS_REPAIR_INDUSTRY_GROUP,
      label: 'Ремонт електроніки та високоточного обладнання',
    },
    {
      value: COMMERCIAL_REPAIR_AND_MAINTENANCE_INDUSTRY_GROUP,
      label: 'Ремонт та обслуговування промислового й комерційного обладнання (крім авто та електроніки)',
    },
    {
      value: PERSONAL_GOODS_REPAIR_INDUSTRY_GROUP,
      label: 'Ремонт особистих та побутових речей',
    },
  ],
  [LAUNDRY_SERVICE_SUB_SECTOR]: [
    {
      value: PERSONAL_CARE_SERVICES_INDUSTRY_GROUP,
      label: 'Перукарні, салони краси та інші послуги з догляду за собою',
    },
    { value: DEATH_CARE_SERVICES_INDUSTRY_GROUP, label: 'Похоронні бюро та крематорії' },
    {
      value: LAUNDRY_SERVICES_INDUSTRY_GROUP,
      label: 'Прання, хімчистка та послуги пралень',
    },
    {
      value: OTHER_PERSONAL_SERVICES_INDUSTRY_GROUP,
      label: 'Інші особисті послуги',
    },
  ],
  [RELIGIOUS_SUB_SECTOR]: [
    {
      value: RELIGIOUS_ORGANIZATIONS_INDUSTRY_GROUP,
      label: 'Релігійні організації',
    },
    {
      value: GRANTMAKING_INDUSTRY_GROUP,
      label: 'Благодійні та грантодавчі організації',
    },
    {
      value: SOCIAL_ADVOCACY_INDUSTRY_GROUP,
      label: 'Соціальні та правозахисні організації',
    },
    {
      value: SOCIAL_ORGANIZATIONS_INDUSTRY_GROUP,
      label: 'Громадські та соціальні об’єднання',
    },
    {
      value: BUSINESS_LABOR_POLITICAL_INDUSTRY_GROUP,
      label: 'Бізнес-, професійні, профспілкові, політичні та подібні організації',
    },
  ],
  [ADMINISTRATION_OF_HOUSING_PROGRAMS_SUB_SECTOR]: [],
  [PRIVATE_HOUSEHOLDS_SUB_SECTOR]: [],
  [EXECUTIVE_LEGISLATIVE_SUB_SECTOR]: [],
  [JUSTICE_PUBLIC_ORDER_SUB_SECTOR]: [],
  [ADMINISTRATION_OF_HUMAN_RESOURCE_SUB_SECTOR]: [],
  [ADMINISTRATION_OF_ENVIRONMENTAL_QUALITY_SUB_SECTOR]: [],
  [ADMINISTRATION_OF_ECONOMIC_PROGRAMS_SUB_SECTOR]: [],
  [SPACE_RESEARCH_SUB_SECTOR]: [],
  [NATIONAL_SECURITY_SUB_SECTOR]: [],
  [MANAGEMENT_OF_COMPANIES_SECTOR]: [],
};
